import { FunctionComponent, memo, useContext } from "react";
import { Box, BoxContent, BoxHeader, BoxHeading, BoxSubheading } from "@edgetier/client-components";
import PhraseTriggersInteractionsTaggedFilters from "./phrase-triggers-interactions-tagged-filters";
import { IProps } from "./phrase-triggers-interactions-tagged.types";
import PhraseTriggersInteractionsTaggedChart from "./phrase-triggers-interactions-tagged-chart";
import PhraseTriggersTotalInteractionsTagged from "./phrase-triggers-total-interactions-tagged";
import { PhraseTriggerContext } from "components-for/phrase-triggers/phrase-trigger-context/phrase-trigger-context";
import "./phrase-triggers-interactions-tagged.scss";

/**
 * Container for interactions tagged chart with filters for date and view
 * @param props.tagId       The ID of current selected tag.
 */
const PhraseTriggersInteractionsTagged: FunctionComponent<IProps> = ({ tagId }) => {
    const { filters, setFilters } = useContext(PhraseTriggerContext);

    return (
        <Box className="phrase-triggers-interactions-tagged">
            <BoxHeader>
                <div>
                    <BoxHeading>
                        <span>Interactions Tagged </span>
                        <PhraseTriggersTotalInteractionsTagged tagId={tagId} />
                    </BoxHeading>
                    <BoxSubheading>
                        Interactions will be counted more than once if tagged by multiple triggers
                    </BoxSubheading>
                </div>

                <PhraseTriggersInteractionsTaggedFilters
                    initialValues={filters}
                    onChange={(formValues) => setFilters(formValues)}
                />
            </BoxHeader>
            <BoxContent>
                <div className="phrase-triggers-interactions-tagged__chart">
                    <PhraseTriggersInteractionsTaggedChart tagId={tagId} />
                </div>
            </BoxContent>
        </Box>
    );
};

export default memo(PhraseTriggersInteractionsTagged);
